import { format } from "date-fns";

import { UserItem } from "protobuf/user_service_pb";
import { FULL_DATE_FORMAT } from "../constants";
import { getDateFromSeconds, getFullName, getRandomString } from "../helpers";
import { USER_TYPE } from "utils/mapped-data";
import { UserDataItem } from "types";
import { RiderScoreListItem, UserStatItem } from "protobuf/user_stats_service_pb";

export function parseUsers(list?: UserItem.AsObject[]) {
  if (list) {
    return list.map((user) => ({
      label: getFullName(user.firstName, user.lastName),
      value: user.id,
    }));
  }

  return [];
}

export function parseUsersTable(search: string, list?: UserDataItem[]) {
  if (list) {
    console.log("client admins list : ", list)
    const data = list.map((user, index) => ({
      key: index,
      driver_name: getFullName(user.firstName, user.lastName),
      user_id: user.serialId,
      document_id: user.documentId,
      phone_no: user.phoneNumber,
      role: USER_TYPE[user.type],
      added_on: format(getDateFromSeconds(user.addedAt), FULL_DATE_FORMAT),
      added_by: user.createdBy,
      vehicle_id: user.vehicle?.map((v) => v.vehicleLicensePlate) || "-",
      date_and_time: "",
      today_shift: getRandomString([
        " 12:00 pm - 08:00 pm",
        "01:00 pm - 09:00 pm",
        "12:00 pm - 08:00 pm",
        "01:00 pm - 09:00 pm",
      ]),
      safety_rating: getRandomString(["1", "2", "3", "4", "5"]),
      user_status: getRandomString(["Active", "In-active", "Blocked"]),
      active_tasks: getRandomString(["1", "2", "3", "4", "5"]),
      task_completed: getRandomString(["1", "2", "3", "4", "5"]),
      organization_name : user.organizationName,
      rider_score: parseFloat(user.riderScores).toFixed(2) || 0,
      action: "",
      raw: user,
    }));
    return data;
  }

  return [];
}

export function parseStats (stats? : UserStatItem.AsObject )  {
  if (!stats) return {};

  return {
    safetyRating: stats.safetyRating || 0,
    totalRides: stats.totalRides || 0,
    totalMileage: stats.totalMileage || 0,
    driverScore: stats.driverScore || 0,
    consistencyScore: stats.consistencyScore || 0,
    rangeScore: stats.rangeScore || 0,
    overallScore: stats.overallScore || 0,
    totalDrivingTime: stats.totalDrivingTime || "0 Hr 0 m",
    totalKilometer: stats.totalKilometer || 0,
  };
};

export function parseRiderScoreGroups(response?: { [key: string]: number}) {
  return {
      bad: response?.bad || 0,
      average: response?.average || 0,
      good: response?.good || 0,
  };
}

export function parseRiderList(response?: { rider_list: RiderScoreListItem[] }) {
  if (!response) return [];

console.log("rider list :++++++++++++++++ ", response.rider_list);
  return response.rider_list.map((rider) => ({
    riderName: rider.getRiderName() || "N/A",
    totalTrips: rider.getTotalTrip() || 0,
    totalDrivenKm: rider.getTotalDrivenKm() || 0,
    riderScore: rider.getRiderScore().toFixed(2)|| "0.00",
    riderPhone: rider.getRiderPhone() || "N/A",
  }));
}

export interface ParsedFeedbackStat {
  category: string;
  count: number;
  key: string;
}
//Display order and labels for feedback categories

const FEEDBACK_DISPLAY_ORDER: { key: string; label: string }[] = [
  { key: "excellent", label: "Excellent" },
  { key: "veryGood", label: "Very Good" },
  { key: "good", label: "Good" },
  { key: "fair", label: "Fair" },
  { key: "poor", label: "Poor" },
];

export const parseFeedbackStats = (
  raw?: Record<string, string | number> | null   
): ParsedFeedbackStat[] => {
  if (!raw || typeof raw !== "object") return [];

  return FEEDBACK_DISPLAY_ORDER.map(({ key, label }) => ({
    key,
    category: label,
    count: Number(raw[key] || 0),   // ✅ Number() handles both "1" and 1
  }));
};